import React, { Component } from 'react';
import { Parallax } from 'react-skrollr';
import { BackgroundImage } from '../../components';

const img1 = 'https://lagunaproperty.com/images/ab1.jpg';
const img2 = 'https://lagunaproperty.com/images/ab2.jpg';

export default class Section1 extends Component {
  render() {
    return (
      <div className="aboutus-section1">
        <div className="background-img1">
          <BackgroundImage image={img1} position="fixed" />
        </div>
        <Parallax
          data={{
            'data-0-start': 'opacity: 0;',
            'data-top-bottom': 'opacity: 1;'
          }}
        >
          <div className="background-img2">
            <BackgroundImage image={img2} />
          </div>
        </Parallax>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AboutUs/Section1.js